import { DefinitionState } from "@/runtime/RuntimeStore";
import { GraphNodeData } from "../node/GraphNode";
import { Edge, Node } from "@xyflow/react";
import { logger } from "@/logging";
import { getEndpointColor, CONSTRAINT_COLOR } from "@/ui/shared/utils";

/**
 * Transform DefinitionState to React flow nodes
 */
export function toReactFlowNodes(
  state: DefinitionState,
  instanceId: string,
): Node<GraphNodeData>[] {
  try {
    return Object.entries(state.nodes).map(([id, node]) => {
      const position = state.positions[id] || {x:0,y:0};
      const isConstraint = node.type.startsWith('struct.');

      return {
        id,
        type: isConstraint ? 'constraintNode' : 'graphNode',
        position,
        draggable: true,
        data: { node, instanceId, isCollapsed: position.isCollapsed },
        ...(!isConstraint ? { width: 200, height: 100 } : {}),
        zIndex: 1,
      };
    });
  } catch(e) {
    logger.error('toReactFlowNodes',e,state.nodes)
    return []
  }
}

/**
 * Transform connections to ReactFlow edges
 */
export function toReactFlowEdges(
  state: DefinitionState
): Edge[] {
  return Object.values(state.connections).map(conn => {
    const [sourceNodeId, sourceEndpoint] = conn.source.split('.');
    const [targetNodeId, targetEndpoint] = conn.target.split('.');

    // Get edge color from source endpoint dataFlow (for trigger/event) or dataType
    const sourceNode = state.nodes[sourceNodeId];
    const endpoint = sourceNode?.endpoints[sourceEndpoint];
    const isStructural = sourceNode?.type.startsWith('struct.');
    const edgeColor = isStructural ? CONSTRAINT_COLOR : getEndpointColor(endpoint?.dataType, endpoint?.dataFlow);

    return {
      id: `${conn.source}->${conn.target}`,
      source: sourceNodeId,
      target: targetNodeId,
      sourceHandle: sourceEndpoint,
      targetHandle: targetEndpoint,
      ...(isStructural ? { type: 'floating', style: { stroke: edgeColor, strokeDasharray: '6 3' } } : { style: { stroke: edgeColor } }),
      selectable: true,
      data: { disabled: conn.disabled ?? false }
    };
  });
}